import React from "react"
import Title from "./Title"
import { FaAngleDoubleRight, FaAlignRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"

const query = graphql`
  {
    allStrapiJobs(sort: {fields: strapiId, order: DESC}) {
      nodes {
        strapiId
        company
        date
        desc {
          id
          name
        }
        position
      }
    }
  }
`
const Jobs = () => {
  const data  = useStaticQuery(query);
  const {allStrapiJobs:{nodes:jobs},
  } = data
  const [value, setValue ] = React.useState(0);
  const {company, position, date, desc} = jobs[value];

  return (
      <section className="section jobs">
        <Title title="experience" />
        <div className="jobs-center">
          {/* btn container */}
          <div className="btn-container">
            {jobs.map((item , index ) =>{
              return <button className={`job-btn $ {index === value && 'active-btn'} `}
               onClick={() => setValue(index)}
               key={item.strapiId}>
                 {item.company}
                 </button>
            })}

          </div>
          {/* job info  */}
          <article className="job-info">
            <h3>{position}</h3>
            <h4>{company}</h4>
            <p className="job-date">{date}</p>
            {desc.map((item) =>{
                return (
                <div key={item.id} className="job-desc">
                  <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                    <p>{item.name}</p>
                  
                </div>
                )
              })}
          </article>
        </div>
      
      </section>
  )
}

export default Jobs
